/**
 * Temporary display switches. Replace with values from Configuration once
 * application-wide display settings are available.
 */
export const SHOW_PAYMENT_FEE = false;
